import * as MEDICINE from '../constants/medicine';


export default {
  [MEDICINE.MUTATE_LIST_MEDICINE]: (state, data) => {
    state.list = data;
  }
}


// WEBPACK FOOTER //
// ./src/store/medicine/mutations.js